import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diff = now - date;
  
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes}m ago`;
  if (hours < 24) return `${hours}h ago`;
  if (days < 7) return `${days}d ago`;
  
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
  });
};

export const truncateText = (text, maxLength) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const getConditionColor = (condition) => {
  const colors = {
    'new': 'bg-emerald-100 text-emerald-700',
    'like-new': 'bg-teal-100 text-teal-700',
    'good': 'bg-blue-100 text-blue-700',
    'fair': 'bg-amber-100 text-amber-700',
    'poor': 'bg-stone-100 text-stone-700'
  };
  return colors[condition] || colors['good'];
};

export const getStatusColor = (status) => {
  const colors = {
    'pending': 'bg-amber-100 text-amber-800',
    'accepted': 'bg-emerald-100 text-emerald-800',
    'declined': 'bg-red-100 text-red-800',
    'active': 'bg-emerald-100 text-emerald-800',
    'traded': 'bg-indigo-100 text-indigo-800'
  };
  return colors[status] || 'bg-stone-100 text-stone-800';
};
